var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",class:{'has-footer': _vm.hasNav },attrs:{"id":"app"}},[_c('div',{staticClass:"app-body"},[_c('transition',{attrs:{"name":_vm.directionClass}},[_c('keep-alive',[_c('router-view',{key:_vm.pagekey})],1)],1)],1),_vm._v(" "),(_vm.hasNav)?_c('tab-bar',{staticClass:"app-tab"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf4c5a1e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = nDmC
// module chunks = 50